<template id="Premiere_demande">
<Modele id="Premiere_demande"></Modele>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Premiere_demande',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Conduite/Premiere_demande.vue